<template>
  <content-page class="procedures"
                :title="$t('procedures.title')"
                :loading="isLoading">
    <card-flex>
      <template v-slot:after>
        <procedures-helper :offer="currentOffer"></procedures-helper>
      </template>
    </card-flex>
  </content-page>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfigLoader from '@/utils/components/ConfigLoader.vue';
import CardFlex from '@/utils/components/CardFlex.vue';
import ProceduresHelper from '@/components/procedures/ProceduresHelper.vue';
import ContentPage from '@/components/layout/ContentPage.vue';

export default {
  name: 'procedures',
  extends: ConfigLoader,
  components: {
    CardFlex,
    ContentPage,
    ProceduresHelper,
  },
  computed: {
    ...mapGetters({
      currentOffer: 'configStore/offer',
    }),
  },
  watch: {
    projectSelected: {
      immediate: true,
      handler() {
        if (!this.isCommissionaire) {
          this.$router.push({ name: 'home' }).catch(() => {});
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.procedures {
  min-height: 600px;
  margin: 0;
  @include breakpoint(tablet) {
    margin: 0 20px;
  }
  @include breakpoint(wide) {
    margin: 0 $--wide-margin;;
  }
  @include breakpoint(wide-xl) {
    margin: 0 $--wide-xl-margin;
  }
  :deep(.card-flex) {
    .el-card__body {
      padding: 0 20px 0 0;
    }
    .card-flex {
      &__after {
        flex: 1;
        width: 100%;
        margin-left: 0;
      }
      &__content {
        flex: inherit;
        margin: unset;
      }
      &__wrapper {
        align-items: inherit;
      }
    }
  }
}
</style>
